import { useContext } from 'react'
import { SCORMContext } from '../contexts'

export const useSCORMContext = () => useContext(SCORMContext)
